import {
  INITIAL,
  SET_DOCJSON,
  SET_DEPENDENCY_JSON,
  SET_DYNAMIC_OPTION_DONE,
  UPDATE_DYNAMIC_OPTION_DONE,
  SET_ORG_ID_CONST,
  SET_CHANGES_LOG,
  SET_STORE_VALS,
  SET_ATHENA_STORAGE,
  UPDATE_ATHENA_STORAGE,
  SET_ONE_SIDE_PDF_KEY,
  SET_ACTIVE_TAB,
  SET_FOCUSED_SERVICE_ID,
  RERENDER,
  SET_DIALOG_DATA,
  SET_VALIDATION_ERROR,
  UPDATE_VALIDATION_ERROR,
  CLEAR_VALIDATION_ERROR,
  ADD_CHILDREN,
  CHANGE_FORM_VALUES,
} from "./dynamicFormsActionTypes";

const initialState = {
  DOCJSON: null,
  dependency_json: null,
  dynamicOption_Done: {},
  ORG_ID_CONST: "",
  changesLog: {},
  storeVals: {},
  athenaStorage: {},
  one_side_PDF_Key: null,
  canQuit: false,
  activeTabs: {},
  focusedServiceID: null,
  DialogData: null,
  validationError: {},
  UJ_JSON: [],
  formValues: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case INITIAL:
      return initialState;
    case SET_DOCJSON:
      console.log("JSON", action.payload);

      return { ...state, DOCJSON: action.payload };
    case SET_DEPENDENCY_JSON:
      return { ...state, dependency_json: action.payload };
    case SET_DYNAMIC_OPTION_DONE:
      return { ...state, dynamicOption_Done: action.payload };
    case UPDATE_DYNAMIC_OPTION_DONE:
      return {
        ...state,
        dynamicOption_Done: {
          ...state.dynamicOption_Done,
          [action.payload.key]: action.payload.hash,
        },
      };
    case SET_ORG_ID_CONST:
      return { ...state, ORG_ID_CONST: action.payload };
    case SET_CHANGES_LOG:
      return { ...state, changesLog: action.payload };
    case SET_STORE_VALS:
      return { ...state, storeVals: action.payload };
    case SET_ATHENA_STORAGE:
      return { ...state, athenaStorage: action.payload };
    case UPDATE_ATHENA_STORAGE:
      return {
        ...state,
        athenaStorage: {
          ...state.athenaStorage,
          [action.payload.key]: action.payload.value,
        },
      };
    case SET_ONE_SIDE_PDF_KEY:
      return { ...state, one_side_PDF_Key: action.payload };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTabs: {
          ...state.activeTabs,
          [action.payload.id]: action.payload.index,
        },
      };
    case SET_FOCUSED_SERVICE_ID:
      return { ...state, focusedServiceID: action.payload };
    case RERENDER:
      return { ...state, canQuit: !action.payload };
    case SET_DIALOG_DATA:
      return { ...state, DialogData: action.payload };
    case SET_VALIDATION_ERROR:
      return { ...state, validationError: action.payload };
    case UPDATE_VALIDATION_ERROR:
      return {
        ...state,
        validationError: {
          ...state.validationError,
          [action.payload.key]: action.payload.value,
        },
      };
    case CLEAR_VALIDATION_ERROR:
      const newValidationError = { ...state.validationError };
      delete newValidationError[action.payload];
      return { ...state, validationError: newValidationError };
    case ADD_CHILDREN:
      return { ...state, UJ_JSON: action.UJ };
    case CHANGE_FORM_VALUES:
      return { ...state, formValues: action.formValues };
    default:
      return state;
  }
}
